import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from 'react-bootstrap-dialog';
import FileUploadMultiple, { File } from 'components/FileUploadMultiple';
import {
  Row,
  Col,
  Modal,
  Form,
  Button,
  OverlayTrigger,
  Tooltip,
  Spinner
} from 'react-bootstrap';
import arrayAppend from 'helpers/array-append';
import { api } from 'services';
import { toast } from 'react-toastify';
import Currency, { currencyReverse, DollarCurrency, EuroCurrency,
  CurrencyPlainText,
  CurrencyDollarPlainText,
  CurrencyEuroPlainText, } from 'helpers/Currency';
import { parseDate } from 'helpers/date';
import { connect } from 'react-redux';
import { LOADING } from 'store';
import PadLock from 'components/PadLock';
import style from './style.module.scss';

const OtherComprovations = ({
  loading,
  actionId,
  otherComprovations,
  setOtherComprovations,
  editable,
  maxValue,
  periodFunds,
  currency,
  funds
}) => {
  const [showModal, setShowModal] = useState(false);
  const [id, setId] = useState('');
  const [value, setValue] = useState('');
  const [description, setDescription] = useState('');
  const [files, setFiles] = useState([]);
  const [filesComments, setFilesComments] = useState([]);
  const [addMaxValue, setAddMaxValue] = useState(0);
  const [total, setTotal] = useState(0);
  const [isLoad, setLoad] = useState(false);
  const [currencyValue, setCurrencyValue] = useState('');
  const [cotacao, setCotacao] = useState('');

  useEffect(() => {
    var sum = 0;
    otherComprovations.forEach((description) => (sum += description.value/(description.value_cotacao?description.value_cotacao:1)));
    setTotal(sum);
  }, [otherComprovations]);

  const { t } = useTranslation();
  let dialog;

  const handleHideModal = () => {
    setShowModal(false);
    setId('');
    setValue('');
    setAddMaxValue(0);
    setDescription('');
    setFiles([]);
    setFilesComments([]);
  };

  const handleEdit = k => {
    const expenseDescription = otherComprovations[k];
    setId(expenseDescription.id);
    setValue(expenseDescription.value);
    setAddMaxValue(expenseDescription.value);
    setDescription(expenseDescription.description);
    setShowModal(true);
    if(expenseDescription.value_cotacao){
      setCurrencyValue('1');
      setCotacao(expenseDescription.value_cotacao);
    }
  };

  const deleteDescription = id => {
    Dialog.setOptions({
      defaultOkLabel: t('label:yes'),
      defaultCancelLabel: t('label:no'),
      primaryClassName: 'btn-success',
      defaultButtonClassName: 'btn-danger'
    });

    dialog.show({
      title: t('title:other comprovation delete'),
      body: t('phrase:are you sure?'),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          api.delete(`expense-descriptions/${id}`).then(() => {
            refreshExpenseDescriptions();
            toast.success('Deletado com sucesso!');
          });
        })
      ],
      bgSize: 'small'
    });
  };

  const handleSave = () => {
    const formData = new FormData();
    setLoad(true);
    toast.dismiss();
    if (!!id) formData.append('_method', 'put');
    formData.append('status_id', 6);

    formData.append('is_other_comprovation', true);
    formData.append('action_id', actionId);
    formData.append('value', value ? currencyReverse(value) : "0.00");
    formData.append('description', description);
    formData.append('vinculated_nf', 0);
    arrayAppend(formData, 'files', files);
    arrayAppend(formData, 'files_comments', filesComments);
    if(getCurrency() === '1' && currency!=='1'){
      formData.append('value_cotacao', cotacao);
    }
    api
      .post(
        !!id ? `expense-descriptions/${id}` : 'expense-descriptions',
        formData
      )
      .then(() => {
        handleHideModal();
        refreshExpenseDescriptions();
      })
      .finally(() => loading(false) && setLoad(false))
      .catch(() => loading(false) && setLoad(false));
  };

  const refreshExpenseDescriptions = async () => {
    return api
      .get(`actions/${actionId}/expense-descriptions`)
      .then(({ data }) =>
        setOtherComprovations(
          data
            .filter(comprovation => comprovation.service_provider === null)
            .map(description => {
              if (description.value) {
                return {
                  ...description,
                  ...{
                    hidden: true
                  }
                };
              } else {
                return {
                  ...description
                };
              }
            })
        )
      );
  };

  const setHidden = (value, k) => {
    const updateArray = [...otherComprovations];
    updateArray[k].hidden = value;
    setOtherComprovations(updateArray);
  };

  const getListSelectCurrency = () => {
    let retorno = [
      (<option value="1">R$</option>)
    ];
    if(currency === '2')
    retorno.push((<option value="2">$</option>))
    if(currency === '3')
    retorno.push((<option value="3">€</option>))
    
    return retorno;
  }

  const getListSelectCotacao = () => {
    let pf = periodFunds.filter(a=> funds.filter(b=>b.fund_id === a.id)[0]);
    if(cotacao==='')
    setCotacao(pf[0]?pf[0].value_cotacao:'');
    return pf.map(a=>{
      return (<option value={a.value_cotacao}>{'R$ '+a.value_cotacao.replace('.',',')}</option>)
    });
  }

  const getCurrency = () => {
    return currencyValue!==''?currencyValue:currency;
  }

  const getText = () => {
    let valor = (value!==''?parseFloat(currencyReverse(value)).toFixed(2):'0.00').toString().replace('.',',');
    return 'R$ '+valor+' = '+(currency==='2'?'$ ':'€ ')+
    (currencyReverse(valor)/(cotacao?cotacao:1)).toFixed(2).replace('.',',');
  }

  const changeValue = (e) => {

    /**
     * 
     * if (
          currencyReverse(e.target.value) >
          maxValue + addMaxValue
        ) {
          toast.warning(
            `${t('error:not exceed the value of')} R$ ${(
              maxValue + addMaxValue
            ).toLocaleString('pt-BR')}`
          );
          setValue(maxValue + addMaxValue);
          return;
        }
        setValue(e.target.value);
     * 
     */


    const c = () => {
      return getCurrency()==='1'?'R$':(
        getCurrency()==='2'?'$':'€'
      );
    };
    let valor_limite = maxValue + addMaxValue;
    let valor = currencyReverse(e.target.value);
    if(getCurrency() === '1' && currency!=='1')
      valor = valor/(cotacao?cotacao:1);
    
    if (valor > valor_limite) {
      toast.warning(
        `${t('error:not exceed the value of')} R$ ${(
          valor_limite*((getCurrency() === '1' && currency!=='1') && cotacao?cotacao:1)
        ).toLocaleString('pt-BR')}`
      );
      if(getCurrency() === '1' && currency!=='1')
      setValue((maxValue + addMaxValue)*(cotacao?cotacao:1));
      else
      setValue(maxValue + addMaxValue);
      return;
    }
    setValue(e.target.value);
  }

  const getCurrencyTag=()=>{
    switch (getCurrency()) {
      case '1':
        return ( 
        <Currency
          className="col-10"
          value={value}
          onChange={(e) => changeValue(e) }
          required
        />);
        break;
      case '2':
        return ( 
        <DollarCurrency
          className="col-10"
          value={value}
          onChange={(e) => changeValue(e) }
          required
        />);
        break;
      case '3':
        return ( 
        <EuroCurrency
          className="col-10"
          value={value}
          onChange={(e) => changeValue(e) }
          required
        />);
        break;
    
      default:
        break;
    }
  };

  if (!actionId) return <></>;
  return (
    <>
      <Modal size="lg" show={showModal} onHide={handleHideModal}>
        <Modal.Body>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:value')}</Form.Label>
                <div className="row pl-3 pr-3">
                  <Form.Control
                    as="select"
                    value={getCurrency()}
                    onChange={(e) => {
                      setCurrencyValue(e.target.value);
                      const c = () => {
                        return e.target.value==='1'?'R$':(
                          e.target.value==='2'?'$':'€'
                        );
                      };
                      let valor_limite = maxValue + addMaxValue;
                        let valor = currencyReverse(value);
                        if(e.target.value === '1' && currency!=='1')
                          valor = valor/(cotacao?cotacao:1);
                        
                        if (valor > valor_limite) {
                          toast.warning(
                            `${t('error:not exceed the value of')} ${c()} ${(
                              valor_limite*((e.target.value === '1' && currency!=='1') && cotacao?cotacao:1)
                            ).toLocaleString('pt-BR')}`
                          );
                          if(e.target.value === '1' && currency!=='1')
                          setValue(valor_limite*(cotacao?cotacao:1)+0.00001);
                          else
                          setValue(valor_limite+0.00001);
                        }
                    }}
                    className="col-2"
                  >
                    {getListSelectCurrency()}
                    
                  </Form.Control>
                  
                  {getCurrencyTag()}
                  {/* <Currency
                    className="col-10"
                    value={value}
                    onChange={e => {
                      if (
                        currencyReverse(e.target.value) >
                        maxValue + addMaxValue
                      ) {
                        toast.warning(
                          `${t('error:not exceed the value of')} R$ ${(
                            maxValue + addMaxValue
                          ).toLocaleString('pt-BR')}`
                        );
                        setValue(maxValue + addMaxValue);
                        return;
                      }
                      setValue(e.target.value);
                    }}
                  /> */}
                </div>
                {getCurrency() === '1' && currency!=='1'?(
                <Form.Text className="text-muted">
                  {getText()}
                </Form.Text>
                ):''}
              </Form.Group>
            </Col>
            {
              getCurrency() === '1' && currency!=='1'?(
                <Col md="5">
                  <Form.Group>
                <Form.Label>Cotação</Form.Label>
                <Form.Control
                  as="select"
                  value={cotacao}
                  onChange={(e) => {
                    const c = () => {
                      return getCurrency()==='1'?'R$':(
                        getCurrency()==='2'?'$':'€'
                      );
                    };
                    let valor_limite = maxValue + addMaxValue;
                      let valor = currencyReverse(value);
                      if(getCurrency() === '1' && currency!=='1')
                        valor = valor/(e.target.value?e.target.value:1);
                      
                      if (valor > valor_limite) {
                        toast.warning(
                          `${t('error:not exceed the value of')} ${c()} ${(
                            valor_limite*((getCurrency() === '1' && currency!=='1') && e.target.value?e.target.value:1)
                          ).toLocaleString('pt-BR')}`
                        );
                        if(getCurrency() === '1' && currency!=='1')
                        setValue(valor_limite*(e.target.value?e.target.value:1)+0.00001);
                        else
                        setValue(valor_limite+0.00001);
                      }
                    setCotacao(e.target.value);
                  }}
                >
                  {getListSelectCotacao()}
                  
                </Form.Control>
              
              </Form.Group>
            
                </Col>
              ):''
            }
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:brief description')}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows="4"
                  value={description}
                  onChange={e => setDescription(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <FileUploadMultiple
                files={files}
                setFiles={files => setFiles(files)}
                filesComments={filesComments}
                setFilesComments={filesComments =>
                  setFilesComments(filesComments)
                }
                existingFiles={[]}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              {description.files &&
                description.files.map((file, k) => (
                  <File
                    key={k}
                    extension={file.extension}
                    comment={file.comment}
                    uri={file.uri}
                  />
                ))}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button size="sm" variant="danger" onClick={handleHideModal}>
            {t('label:cancel')}
          </Button>
          {isLoad ? (
            <Row className="float-right text-right">
              <Spinner animation="border" style={{ color: '#e05c17' }} />
              <h6 className="m-2">Salvando...</h6>
            </Row>
          ) : (
              <Button size="sm" onClick={() => handleSave()}>
                {t('label:save')}
              </Button>
            )}
        </Modal.Footer>
      </Modal>
      <Dialog
        ref={component => {
          dialog = component;
        }}
      />
      <Row className="mt-2">
        <Col>
          {!editable ? <PadLock /> : null}
          <Row>
            <Col>
              <h4>{t('title:other comprovations')}</h4>
            </Col>
          </Row>
          {otherComprovations.map((description, k) => (
            <Row className="mt-3" key={k} style={{background:'white'}}>
              <Col
                className={`${style.expenseDescription} ${
                  description.hidden ? style.hidden : null
                  }`}
              >
                {description.hidden ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>{t('label:expand')}</Tooltip>}
                  >
                    <i
                      className="expandIcon fas fa-plus"
                      onClick={() => setHidden(false, k)}
                    />
                  </OverlayTrigger>
                ) : (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip>{t('label:minimize')}</Tooltip>}
                    >
                      <i
                        className="expandIcon fas fa-minus"
                        onClick={() => setHidden(true, k)}
                      />
                    </OverlayTrigger>
                  )}
                <Row>
                  {/* <Col>
                    <Form.Group>
                      <Form.Label>{t('label:value')}</Form.Label>
                      <Currency value={description.value} disabled />
                    </Form.Group>
                  </Col> */}
                  <Col md={description.value_cotacao?'9':'12'}>
                    <Form.Group>
                      <Form.Label>{t('label:value')}</Form.Label>
                      {
                        description.value_cotacao
                        ?
                        (
                          <Currency value={description.value} disabled />
                        )
                        :
                        (currency==='1'?(
                          <Currency value={description.value} disabled />
                        ):currency==='2'?(
                          <DollarCurrency value={description.value} disabled/>
                        ):(
                          <EuroCurrency value={description.value} disabled/>
                        ))
                      }
                    </Form.Group>
                  </Col>
                  {description.value_cotacao?(
                    <Col md={'3'}>
                      <Form.Group>
                        <Form.Label>Cotação</Form.Label>
                        <Currency value={description.value_cotacao} disabled />
                      </Form.Group>
                    </Col>
                  ):''}
                </Row>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Label>{t('label:brief description')}</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows="4"
                        value={description.description}
                        disabled
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    {description.files.map((file,k)=>(
                      <File
                        key={k}
                        extension={file.extension}
                        comment={file.comment}
                        uri={file.uri}
                      />
                    ))}
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col>
                    <Button
                      size="sm"
                      onClick={() => handleEdit(k)}
                      disabled={!editable}
                    >
                      {t('label:edit')}
                    </Button>
                    &nbsp;
                    <Button
                      size="sm"
                      variant="danger"
                      onClick={() => deleteDescription(description.id)}
                      disabled={!editable}
                    >
                      <i className="fas fa-trash" />
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          ))}
          <Row className="mt-2 mb-4">
            <Col>
              <Button
                size="sm"
                variant="dark"
                onClick={() => setShowModal(true)}
                disabled={!editable || parseFloat(maxValue) === 0}
              >
                <i className="fas fa-plus" /> {t('label:add new')}
              </Button>
            </Col>

            <Col className="mt-2 text-right">
              <b>Total:</b>{' '}
              {
              (currency==='1'?'R$ ':(currency==='2'?'$ ':'€ '))+
              parseFloat(total.toFixed(2)).toLocaleString(currency==='2'?'en':'pt')+
              (total % 1 === 0?(currency==='2'?'.':',')+'00':'')
              }
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  loading: payload => dispatch({ type: LOADING, payload })
});

export default connect(mapStateToProps, mapDispatchToProps)(OtherComprovations);
